import { render, staticRenderFns } from "./NewCampaignSidebar.vue?vue&type=template&id=444f1062"
import script from "./NewCampaignSidebar.vue?vue&type=script&lang=js"
export * from "./NewCampaignSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports